import testRoutes from './testRoutes';
import pageRoutes from './pageRoutes';
import externalPagesRoutes from './externalPagesRoutes';

export default [
  ...testRoutes,
  ...externalPagesRoutes,
  ...pageRoutes,
  {
    path: '/*',
    component: '@/pages/home',
    title: '友邻市集',
    meta: {
      analytic: 'home',
    },
  }, // 模糊匹配
];
